import type { Attributes } from '../logger-types';

let staticContext: Attributes = {};
let userContext: Attributes = {};

let resolveRoute: () => string = () => {
  if (typeof window !== 'undefined' && window.location?.pathname) {
    return window.location.pathname;
  }

  return '';
};

export function setStaticContext(values: Attributes): void {
  staticContext = { ...staticContext, ...values };
}

export function setUserContext(userId: string): void {
  userContext = { 'user.id': userId };
}

export function clearUserContext(): void {
  userContext = {};
}

export function setRouteResolver(resolver: () => string): void {
  resolveRoute = resolver;
}

export function resetContext(): void {
  staticContext = {};
  userContext = {};
  resolveRoute = () => {
    if (typeof window !== 'undefined' && window.location?.pathname) {
      return window.location.pathname;
    }

    return '';
  };
}

export function getContextAttributes(): Attributes {
  const attrs: Attributes = { ...staticContext, ...userContext };
  const route = resolveRoute();
  if (route) {
    attrs['route.path'] = route;
  }

  return attrs;
}
